<template>
  <div class="fullGift" v-if="fullgift && fullgift.length">
    <ul class="flex jc-c ai-fe f14 pagination ml10 mr10 br8">
      <li
        :class="{
          'selected f14 fw-b': activeIndex == index,
          btlr8: activeIndex != index && index == 0,
          btrr8: activeIndex != index && index == fullgift.length - 1
        }"
        :style="
          activeIndex == index
            ? { background: item.color, color: '#fff' }
            : { background: item.color + '4D', color: item.color }
        "
        @click="activeHandle(index)"
        class="ta-c f13"
        v-for="(item, index) in fullgift"
        :key="index"
      >
        {{ item.ad_title }}
      </li>
    </ul>
    <swiper :options="fullGiftSwiper" id="swiperFullGift" ref="fullGiftSwiperRef">
      <swiper-slide class="h-100" v-for="(item, index) in fullgift" :key="index">
        <img :src="item.img_path" alt="" class="h-100 w-100 br8 of-c" />
        <div
          :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=19'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
        ></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { bannerClick, isWeixin } from '../../../assets/common/js/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'fullGift',
  components: {},
  props: {
    fullgift: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      activeIndex: 0,
      fullGiftSwiper: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 0,
        on: {
          slideChangeTransitionEnd: function () {
            that.activeIndex = this.activeIndex
          },
          click: function () {
            var activeIndex = this.clickedIndex
            that.bannerClick(
              that.fullgift[activeIndex],
              activeIndex,
              'FULLGIFT-' + (activeIndex + 1)
            )
          }
        }
      }
    }
  },
  computed: {
    fullGiftSwiperRef() {
      return this.$refs.fullGiftSwiperRef.swiper
    }
  },
  mounted() {},
  methods: {
    activeHandle(index) {
      this.activeIndex = index
      this.fullGiftSwiperRef.slideTo(index, 1000, false)
    },
    bannerClick(item, index, flowArea) {
      bannerClick(item, index, flowArea, this, () => {
        this.dataCollection(item, index, flowArea)
      })
    },
    dataCollection(item, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? item.name : item.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : item.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? item.name : item.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    }
  }
}
</script>

<style lang="scss" scoped>
#swiperFullGift {
  height: 1.68rem;
}
.br8 {
  border-radius: 0.08rem;
}
.pagination {
  li {
    width: 0.84rem;
    height: 0.24rem;
    line-height: 0.24rem;
    &.btlr8 {
      border-top-left-radius: 0.08rem;
    }
    &.btrr8 {
      border-top-right-radius: 0.08rem;
    }
    &.selected {
      width: 0.83rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.08rem 0.08rem 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actFullGift.vue